<div class="not-found">
  <div class="not-found__card">
    <img
      class="not-found__icon"
      src="assets/app/img/not-found.svg"
      alt=""
      width="92"
      height="71"
    />
    @if (element()) {
      <h1 class="not-found__title">{{ element() }} not found.</h1>
      <p class="not-found__text">
        It may have been deleted, moved, or you may not have access to it.<br />
        Return to previous page.
      </p>
    } @else {
      <h1 class="not-found__title">Page not found.</h1>
      <p class="not-found__text">Return to previous page or go to dashboard.</p>
    }
    <div class="not-found__actions">
      <button pButton size="small" type="button" (click)="back()">
        <i class="pi pi-chevron-left" aria-hidden="true"></i> Back
      </button>
      @if (!element()) {
        <a
          pButton
          size="small"
          severity="secondary"
          [outlined]="true"
          routerLink="/dashboard"
        >
          Go to dashboard
        </a>
      }
    </div>
  </div>
</div>
